import { ActionReducerMap } from '@ngrx/store';

import { CommonBookingState } from '../store.interface';
import { servicesReducer } from './services.reducer';
import { orderReducer } from './order.reducer';
import { seatMapReducer } from './seat-map.reducer';
import { seatsDirtyReducer } from './seats-dirty.reducer';
import { paymentReducer } from './payment.reducer';
import { disruptionReducer } from './disruption.reducer';
import { redirectReducer } from './redirect.reducer';

export const reducers: ActionReducerMap<CommonBookingState> = {
  services: servicesReducer,
  order: orderReducer,
  seatMap: seatMapReducer,
  seatsDirty: seatsDirtyReducer,
  payment: paymentReducer,
  disruption: disruptionReducer,
  redirect: redirectReducer,
};
